import styled from "styled-components";
import aboutImage from "../../assets/app.png";

export const AboutSection = styled.div`
  width: 100%;
  background: #161645;
  padding: 0;
  position: relative;
  z-index: 10;
  font-family: Raleway;
  overflow: hidden; /* Empêche le débordement */
`;

export const AboutContent = styled.div`
  display: flex;
  margin: 0 auto;
  padding: 10vw 6vw;
  gap: 5vw;
  align-items: flex-start;
  font-family: Raleway;
  max-width: 100%;

  /* Tablet */
  @media (min-width: 768px) {
    padding: 8vw 5vw;
    gap: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 3vw 5.448vw;
    gap: 80px;
  }

  /* Mobile par défaut */
  @media (max-width: 767px) {
    flex-direction: column;
    padding: 12vw 6vw;
    gap: 8vw;
  }
`;

export const LeftAboutPanel = styled.div`
  flex: 1;
  width: 100%;
  font-family: Raleway;
  
  /* Desktop */
  @media (min-width: 1024px) {
    max-width: 500px;
    order: 1;
  }

  /* Mobile et Tablet */
  @media (max-width: 1023px) {
    max-width: 100%;
    order: 2;
  }
`;

export const MainHeader = styled.div`
  color: #9F9898;
  font-size: 6vw;
  font-weight: 200;
  line-height: 1;
  font-family: Raleway;
  margin-bottom: 2vw;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 24px;
  }
`;

export const Title = styled.h2`
  color: white;
  font-size: 10vw;
  font-weight: 200;
  margin: 0 0 8vw 0;
  line-height: 1;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 7vw;
    margin: 0 0 6vw 0;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 48px;
    margin: 0 0 50px 0;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  gap: 4vw;
  margin-bottom: 6vw;
  align-items: flex-start;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    gap: 3vw;
    margin-bottom: 5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    gap: 3vw;
    margin-bottom: 30px;
  }
`;

export const IconCircle = styled.div`
  width: 12vw;
  height: 12vw;
  min-width: 12vw;
  min-height: 12vw;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Tablet */
  @media (min-width: 768px) {
    width: 8vw;
    height: 8vw;
    min-width: 8vw;
    min-height: 8vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
  }
 
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  
  svg {
    width: 60%;
    height: 60%;
  }
`;

export const CardTextContent = styled.div`
  flex: 1;
  font-family: Raleway;
`;

export const CardTitle = styled.h3`
  color: white;
  font-size: 4.5vw;
  font-weight: 200;
  margin: 0 0 2vw 0;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 3vw;
    margin: 0 0 1.5vw 0;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 18px;
    margin: 0 0 5px 0;
  }
`;

export const CardDescription = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 3.5vw;
  line-height: 1.6;
  margin: 0;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

export const RightAboutPanel = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-family: Raleway;
  width: 100%;
  
  /* Mobile et Tablet */
  @media (max-width: 1023px) {
    order: 1;
    margin-bottom: 8vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    order: 2;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  padding-bottom: 75%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    max-width: 80%;
    padding-bottom: 60%;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    max-width: 600px;
    padding-bottom: 50%;
    margin-left: 9.3vw;
  }
`;

export const StyledAboutImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${aboutImage});
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  z-index: 2;
  font-family: Raleway;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 3;
  }
`;

export const VideoCard = styled.div`
  position: absolute;
  bottom: 4vw;
  right: 4vw;
  width: 70%;
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 3vw 4vw;
  display: flex;
  align-items: center;
  gap: 2vw;
  z-index: 10;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    width: 65%;
    padding: 2vw 3vw;
    bottom: 3vw;
    right: 3vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 60%;
    max-width: 250px;
    padding: 15px 20px;
    gap: 10px;
    bottom: 20px;
    right: 20px;
  }
`;

export const VideoCardText = styled.div`
  flex: 1;
  line-height: 1.2;
  font-family: Raleway;
`;

export const VideoTime = styled.div`
  color: rgba(255, 255, 255, 0.9);
  font-size: 3vw;
  font-weight: 200;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

export const VideoTitle = styled.div`
  color: white;
  font-size: 3.5vw;
  font-weight: 200;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

export const VideoPlayButton = styled.div`
  width: 10vw;
  height: 10vw;
  background: #ffffff;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    width: 7vw;
    height: 7vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 40px;
    height: 40px;
  }
`;

export const PlayIcon = styled.span`
  color: black;
  font-size: 4vw;
  margin-left: 0.5vw;
  font-family: Raleway;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 3vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 16px;
    margin-left: 3px;
  }
`;

export const Signature = styled.div`
  position: absolute;
  bottom: 3vw;
  right: 3vw;
  width: 20vw;
  height: auto;
  z-index: 11;
  font-family: Raleway;
  
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    opacity: 0.8;
  }

  /* Tablet */
  @media (min-width: 768px) {
    width: 15vw;
    bottom: 2.5vw;
    right: 2.5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 90px;
    bottom: 15px;
    right: 15px;
  }

  /* Mobile petit */
  @media (max-width: 480px) {
    width: 15vw;
    bottom: 2vw;
    right: 2vw;
  }
`;

export const IconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;